import { useEffect } from 'react';

interface UseAbortRequestResult {
  abortSignal: AbortSignal;
}

export const useAbortRequest = (): UseAbortRequestResult => {
  const abortController = new AbortController();
  useEffect(() => {
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { abortSignal: abortController.signal };
};
